import { useContext } from 'preact/hooks';
import { ControlsContext } from '../contexts/controlsContext';

export function useControls() {
  return useContext(ControlsContext);
}
